import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { Field, propTypes as PT, reduxForm } from 'redux-form';
import { Button } from 'antd';

import TextArea from '../Fields/TextArea';

import { NOTE_DISPLAY_FORM_NAME as FORM_NAME } from '../../constants';
import * as actions from '../../actions';

import s from './styles.less';

const propTypes = {
  ...PT,
  updateNotes: PropTypes.func.isRequired,
};

const NoteDisplay = ({ handleSubmit, updateNotes, pristine, submitting }) => (
  <form onSubmit={handleSubmit(updateNotes)}>
    <Field name="notes" component={TextArea} rows={3} />
    <div className={s.action}>
      <Button
        htmlType="submit"
        disabled={pristine}
        type="primary"
        loading={submitting}
        ghost
      >
        Update
      </Button>
    </div>
  </form>
);

NoteDisplay.propTypes = propTypes;

export default compose(
  connect(
    null,
    {
      updateNotes: actions.updateCancellationNotes,
    },
  ),
  withProps(({ content }) => ({
    initialValues: {
      notes: content,
    },
  })),
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
  }),
)(NoteDisplay);
